import { gql } from '@apollo/client';

export const FILTERED_FUNDERS = gql`
  query FilteredFunders($input: AllFundersInput!) {
    funders: filteredFunders(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          interventions {
            id
          }
          institutions {
            id
          }
          programmes {
            id
          }
          serviceProviders {
            id
          }
          users {
            id
          }
        }
      }
    }
  }
`;
